import { GridValueGetterParams } from '@mui/x-data-grid-premium';
import { ALL_APPS } from 'constants/appConstants';

export const columns = [
  {
    field: 'name',
    headerName: 'Name',
    description: 'Name of Sub Org',
    type: 'string',
    flex: 0.5,
    hideable: false,
    app: ALL_APPS.ORG_SETTINGS.id,
  },
  {
    field: 'website',
    headerName: 'Website',
    description: 'Website',
    type: 'string',
    flex: 0.5,
    app: ALL_APPS.ORG_SETTINGS.id,
  },
  {
    field: 'timezone',
    headerName: 'Timezone',
    description: 'Timezone for this sub org',
    type: 'string',
    flex: 0.5,
    valueGetter: (params: GridValueGetterParams) =>
      `${params.row.timezone.replace(/[/_]/g, ' ')}`,
    app: ALL_APPS.ORG_SETTINGS.id,
  },
];
